import { createSlice } from '@reduxjs/toolkit';

export const loadingSteps = {
  AUTH_LOADING: 'AUTH_LOADING',
  USER_LOADING: 'USER_LOADING',
  TOKEN_LOADING: 'TOKEN_LOADING',
  ORG_LOADING: 'ORG_LOADING',
};

const appLoadingSlice = createSlice({
  name: 'appLoading',
  initialState: {
    loadingStep: loadingSteps.AUTH_LOADING,
  },
  reducers: {
    setLoadingStep: (state, action) => {
      state.loadingStep = action.payload;
    },
  },
});

export const { setLoadingStep } = appLoadingSlice.actions;
export default appLoadingSlice.reducer;
